<div class="dna-select">
  <div class="dna-select__header">
    <div class="dna-select__titulo-row">
      <div>
        <h3 class="dna-select__titulo">{{ titulo }}</h3>
        <p class="dna-select__subtitulo" *ngIf="nomeSku">{{ nomeSku }}</p>
      </div>
      <button type="button" class="dna-select__fechar" (click)="onFechar()" aria-label="Fechar">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <sgt-input-search
      *ngIf="passo === 1"
      class="dna-select__busca"
      placeholder="Buscar por nome ou Biotipo..."
      [debounce]="200"
      (searched)="onBuscar($event)"
    ></sgt-input-search>
  </div>

  <div class="dna-select__body" [class.dna-select__body--conferencia]="passo === 2">
    <ng-container *ngIf="passo === 1">
      <div *ngIf="isLoading" class="dna-select__loading">
        <i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Carregando DNAs...
      </div>

      <ng-container *ngIf="!isLoading">
        <ul class="dna-select__lista">
          <li *ngFor="let item of itensFiltrados; trackBy: trackById">
            <button type="button" class="dna-select__opcao" (click)="escolherDna(item)">
              <span class="dna-select__simbolo">
                <img *ngIf="item.imagemUrl; else iconeDna" [src]="item.imagemUrl" alt="" />
                <ng-template #iconeDna>
                  <i [class]="item.icone || 'fas fa-dna'" aria-hidden="true"></i>
                </ng-template>
              </span>
              <span class="dna-select__identidade">
                <span class="dna-select__nome">{{ item.nome }}</span>
                <span class="dna-select__biotipo">{{ resumo(item) }}</span>
              </span>
              <span class="dna-select__herdeiros" *ngIf="item.skusCount !== undefined">
                <span class="dna-select__herdeiros-total">{{ item.skusCount }}</span>
                <span class="dna-select__herdeiros-rotulo">SKUs</span>
              </span>
            </button>
          </li>
        </ul>

        <div *ngIf="itensFiltrados.length === 0" class="dna-select__empty">
          Nenhum DNA ativo encontrado para esta busca.
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="passo === 2 && selecionado">
      <div class="dna-select__escolhido">
        <span class="dna-select__simbolo dna-select__simbolo--destaque">
          <img *ngIf="selecionado.imagemUrl; else iconeEscolhido" [src]="selecionado.imagemUrl" alt="" />
          <ng-template #iconeEscolhido>
            <i [class]="selecionado.icone || 'fas fa-dna'" aria-hidden="true"></i>
          </ng-template>
        </span>
        <span class="dna-select__identidade">
          <span class="dna-select__nome dna-select__nome--destaque">{{ selecionado.nome }}</span>
          <span class="dna-select__biotipo">{{ resumo(selecionado) }}</span>
        </span>
        <button type="button" class="dna-select__trocar" (click)="voltarPasso1()">Trocar</button>
      </div>

      <p class="dna-select__aviso" *ngIf="modoTroca">
        <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
        <span>
          Este SKU deixa de herdar de <strong>{{ nomeDnaAtual }}</strong> e passa a ser avaliado
          pelas expectativas abaixo. Os parâmetros informados neste produto continuam valendo.
        </span>
      </p>

      <p class="dna-select__secao-titulo">O que este SKU passa a herdar</p>

      <ul
        class="dna-select__previa"
        *ngIf="isLoadingParametros"
        aria-busy="true"
        aria-label="Carregando os parâmetros do DNA"
      >
        <li class="dna-select__previa-linha" *ngFor="let linha of linhasSkeleton">
          <span class="dna-select__sk dna-select__sk--label"></span>
          <span class="dna-select__sk dna-select__sk--valor"></span>
        </li>
      </ul>

      <ul class="dna-select__previa" *ngIf="!isLoadingParametros && linhas.length">
        <li class="dna-select__previa-linha" *ngFor="let linha of linhas; trackBy: trackLinhaByNumero">
          <span class="dna-select__previa-label">{{ linha.label }}</span>
          <span class="dna-select__previa-valores">
            <span class="dna-select__previa-valor">{{ linha.valor }}</span>
            <span class="dna-select__previa-projecao" *ngIf="linha.projecao">
              {{ linha.projecao }}
            </span>
          </span>
        </li>
      </ul>

      <p class="dna-select__nota">
        <i class="fas fa-code-branch" aria-hidden="true"></i>
        <span>
          Precisa que este produto tenha expectativa diferente da família? Vincule primeiro e
          registre a <strong>mutação</strong> depois, no parâmetro específico — ela vale só para
          este SKU e não altera o DNA.
        </span>
      </p>
    </ng-container>
  </div>

  <div class="dna-select__footer">
    <span class="dna-select__nota-rodape" *ngIf="passo === 1">
      <i class="fas fa-info-circle" aria-hidden="true"></i> {{ notaRodape }}
    </span>

    <div class="dna-select__footer-actions" *ngIf="passo === 2">
      <button type="button" class="btn btn-light" (click)="onFechar()">Cancelar</button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="isLoadingParametros"
        (click)="onConfirmar()"
      >
        {{ rotuloConfirmacao }}
      </button>
    </div>
  </div>
</div>
